import { get, isEmpty } from 'lodash-es';

const DB_CONSTANTS = {
  "DATABASE_GENERATORS" : {
    "assigned": "assigned",
    "identity": "auto increment",
    "uniqueid": "unique id",
    "sequence": "sequence"
  },
  "RELATION_CASCADE_OPTIONS":{
    "NONE": "None",
    "REMOVE": "Remove"
  }
}

export class DBPropertiesFactory {
  result: any = {
    properties: {
      'wm.plugins.database.base': {
        dbobjectname: { type: 'string', required: true, maxlength: 64 },
      },
      'wm.plugins.database.db': {
        package: { type: 'string', required: true, disabled: true },
      },
      'wm.plugins.database.table.base': {
        entityname: { type: 'string', disabled: true },
        type: { type: 'string', disabled: true },
        schema: { type: 'schemaoptions', value: '', disabled: true },
        catalog: { type: 'string', required: true, disabled: true },
        defaultfilter: { type: 'string', required: false, disabled: false },
        primarykey: { type: 'primarykeyoptions', show: true },
        uniquekey: {"type": "uniquekeyoptions", "show": true},
        pktype: {
          type: 'list',
          required: true,
          disabled: false,
          value: 'single',
          options: { single: 'single', composite: 'composite' },
          show: true,
        },
        vpk: { type: 'boolean', value: false, disabled: false, show: false },
        columns: { type: 'list', options: {}, value: '', show: true },
      },
      'wm.plugins.database.table.temporals': {
        temporaltype: { type: 'string', disabled: true, show: true },
      },
      'wm.plugins.database.column.base': {
        fieldname: { type: 'string', disabled: true },
        sqltype: { type: 'list', required: true, options: {}, value: '' },
        javatype: {
          type: 'list',
          required: true,
          options: {},
          value: '',
        },
        length: {
          type: 'number',
          show: false,
          required: true,
          value: 255,
          min: 1,
        },
        precision: { type: 'number', show: false, required: true, min: 1 },
        scale: { type: 'number', show: false, required: true, min: 0 },
      },
      'wm.plugins.database.column.temporal': {
        temporalcolumntype: { type: 'string', disabled: true, show: true },
        ishidden: { type: 'boolean', value: false, disabled: false },
      },
      'wm.plugins.database.column.constraints': {
        nullable: { type: 'boolean', value: true },
        ispk: { type: 'boolean', value: false, show: false },
        unique: { type: 'boolean', value: false, disabled: true },
        partofuniquekey: { type: 'boolean', value: false, disabled: true },
        isfk: { type: 'boolean', value: false, disabled: true },
        ispartofpk: { type: 'boolean', value: false, disabled: true },
        generatortype: {
          type: 'label',
          options: DB_CONSTANTS.DATABASE_GENERATORS,
          value: '',
        },
        generatorvalue: { type: 'label', required: true },
        virtualpk: {
          type: 'boolean',
          value: false,
          disabled: true,
          show: false,
        },
        columnidentifier: { type: 'string', value: '', show: false },
      },
      'wm.plugins.database.column.datavalue': {
        defaultvalue: { type: 'string', value: '', show: true },
        valuetype: {
          type: 'list',
          options: {},
          value: 'user-defined',
          show: true,
          required: true,
        },
        serverproperty: {
          type: 'list',
          options: {},
          value: '',
          show: false,
          required: true,
        },
        appenvproperty: {
          type: 'list',
          options: {},
          value: '',
          show: false,
          required: true,
        },
        userinsertable: {
          type: 'boolean',
          value: true,
          show: true,
          disabled: false,
        },
        userupdatable: {
          type: 'boolean',
          value: true,
          show: true,
          disabled: false,
        },
        serverinsertable: {
          type: 'boolean',
          value: true,
          show: true,
          disabled: false,
        },
        serverupdatable: {
          type: 'boolean',
          value: true,
          show: true,
          disabled: false,
        },
        databaseinsertable: {
          type: 'boolean',
          value: false,
          show: true,
          disabled: true,
        },
        databaseupdatable: {
          type: 'boolean',
          value: false,
          show: true,
          disabled: true,
        },
        appenvinsertable: {
          type: 'boolean',
          value: true,
          show: true,
          disabled: false,
        },
        appenvupdatable: {
          type: 'boolean',
          value: true,
          show: true,
          disabled: false,
        },
        validators: {
          type: 'validatorslist',
          options: {},
          required: true,
          value: '',
          show: true,
        },
      },
      'wm.plugins.database.relation': {
        fieldname: { type: 'string', disabled: true },
        targettable: { type: 'string', required: true, disabled: true },
        cardinality: { type: 'string', required: true, disabled: true },
        sourcetable: { type: 'string', required: true, disabled: true },
        relatedcolumns: { type: 'table', required: true, disabled: true },
        virtual: { type: 'boolean', required: false, disabled: true },
      },
      'wm.plugins.database.relation.fetchoptions': {
        fetchparent: {
          type: 'boolean',
          value: true,
          show: true,
          disabled: false,
        },
        parentcolumnsfilter: { type: 'fetchtableoptions', show: true },
      },
      'wm.plugins.database.relation.cascadeoptions': {
        cascadeenabled: {
          type: 'boolean',
          value: false,
          show: true,
          disabled: false,
        },
        cascaderemove: {
          type: 'cascadelist',
          options: DB_CONSTANTS.RELATION_CASCADE_OPTIONS,
          value: 'NONE',
          show: true,
          required: true,
        },
      },
    },
    propertyGroups: [
      { name: 'db-basicinfo', namekey: 'basicinfo', parent: '' },
      { name: 'db-table-basicinfo', namekey: 'basicinfo', parent: '' },
      { name: 'db-table-column-basicinfo', namekey: 'basicinfo', parent: '' },
      { name: 'db-table-relation-basicinfo', namekey: 'basicinfo', parent: '' },
      {
        name: 'db-table-column-datavalue-basicinfo',
        namekey: 'basicinfo',
        parent: '',
      },
      {
        name: 'db-table-relation-fetch-options',
        namekey: 'basicinfo',
        parent: '',
      },
      {
        name: 'details',
        properties: [
          'dbobjectname',
          'fieldname',
          'temporalcolumntype',
          'sqltype',
          'length',
          'precision',
          'scale',
          'javatype',
          'ishidden',
        ],
        parent: 'db-table-column-basicinfo',
      },
      {
        name: 'datavalue',
        properties: [
          'valuetype',
          'defaultvalue',
          'serverproperty',
          'appenvproperty',
          'userinsertable',
          'userupdatable',
          'serverinsertable',
          'serverupdatable',
          'databaseinsertable',
          'databaseupdatable',
          'appenvinsertable',
          'appenvupdatable',
        ],
        parent: 'db-table-column-datavalue-basicinfo',
      },
      {
        name: 'constraints',
        properties: [
          'nullable',
          'ispartofpk',
          'generatortype',
          'generatorvalue',
          'partofuniquekey',
          'isfk',
        ],
        parent: 'db-table-column-basicinfo',
      },
      {
        name: 'details',
        properties: [
          'dbobjectname',
          'entityname',
          'type',
          'temporaltype',
          'schema',
          'catalog',
          'defaultfilter',
        ],
        parent: 'db-table-basicinfo',
      },
      {
        name: 'primarykey',
        properties: ['primarykey'],
        parent: 'db-table-basicinfo',
      },
      {
        name: 'uniquekey',
        properties: ['uniquekey'],
        parent: 'db-table-basicinfo',
      },
      {
        name: 'validators',
        properties: ['validators'],
        parent: 'db-table-column-datavalue-basicinfo',
      },
      { properties: ['dbobjectname', 'package'], parent: 'db-basicinfo' },
      {
        name: 'details',
        properties: [
          'dbobjectname',
          'fieldname',
          'sourcetable',
          'targettable',
          'cardinality',
          'relatedcolumns',
          'virtual',
        ],
        parent: 'db-table-relation-basicinfo',
      },
      {
        name: 'cascadeoptions',
        properties: ['cascadeenabled', 'cascaderemove'],
        parent: 'db-table-relation-fetch-options',
      },
      {
        name: 'fetchoptions',
        properties: ['fetchparent', 'parentcolumnsfilter'],
        parent: 'db-table-relation-fetch-options',
      },
    ],
  };

  properties: any = this.result.properties;
  propertyGroups: any = this.result.propertyGroups;

  

  getWidgetProperties(widgetType: string) {
    let propsObj = get(propertiesList, widgetType);
    if (isEmpty(this.result.properties)) {
      return {};
    }
    const widgetProps = this.getPropertiesOf(propsObj?.widget,propsObj?.parent);
    return widgetProps;
  }

  getPropertiesOf(widget: string, parents?: string | string[]) {
    let result: any = {};
    if (!parents) {
      result = JSON.parse(JSON.stringify(this.properties[widget]));
    } else {
      parents = Array.isArray(parents) ? parents : [parents];
      parents.push(widget);
      parents.forEach((parent) => {
        Object.keys(this.properties?.[parent] || {}).forEach((propName) => {
          if (!result[propName]) {
            result[propName] = {};
          }
          Object.keys(this.properties[parent][propName]).forEach((key) => {
            result[propName][key] = this.properties[parent][propName][key];
          });
        });
      });
    }

    Object.keys(result).forEach((propName) => {
      if (!result[propName].hasOwnProperty('show')) {
        result[propName].show = true;
      }
      result[propName].disabled = result[propName].disabled || false;
    });

    return result;
  }

  getPropertyGroups() {
    return this.propertyGroups;
  }
}

const propertiesList: any = {
  'wm-db-table': {
    widget: 'wm.plugins.database.base',
    parent: ['wm.plugins.database.table.base'],
  },
  'wm-db-table-column': {
    widget: 'wm.plugins.database.base',
    parent: [
      'wm.plugins.database.column.base',
      'wm.plugins.database.column.constraints',
      'wm.plugins.database.column.datavalue',
      'wm.plugins.database.column.temporal'
    ],
  },
  'wm-db-column-relation': {
    widget: 'wm.plugins.database.base',
    parent: [
      'wm.plugins.database.relation',
      'wm.plugins.database.relation.cascadeoptions',
      'wm.plugins.database.relation.fetchoptions',
      'wm.plugins.database.relation.parentfetchoptions',
    ],
  },
  'wm-db': {
    widget: 'wm.plugins.database.base',
    parent: ['wm.plugins.database.db'],
  },
};

export let dbpropFactory = new DBPropertiesFactory();